const DataTableControlBar = ({ table }) => {
    const { meta, pagination } = table;
    const fromItem = meta?.from || 0;
    const toItem = meta?.to || 0;
    const totalItems = meta?.total || 0;

    return (
        <div className="flex w-full items-center justify-between">
            <div className="flex items-center gap-2">
                <span className="text-small text-default-500">
                    Rows per page:
                </span>
                <select
                    className="text-small text-default-500 cursor-pointer bg-transparent outline-none"
                    onChange={pagination.onPerPageChange}
                    value={pagination.perPage}
                >
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
            <div className="text-small text-default-500">
                Menampilkan{" "}
                <span className="text-default-700 font-medium">{fromItem}</span>{" "}
                - <span className="text-default-700 font-medium">{toItem}</span>{" "}
                dari{" "}
                <span className="text-default-700 font-medium">
                    {totalItems}
                </span>
            </div>
        </div>
    );
};

export default DataTableControlBar;
